module.exports = __webpack_public_path__ + "static/media/F-wrench.71987d68.png";